import { create } from './advnacedActions';

const initialState = {
  name: '',
  description: '',
  isLoading: true,
  error: null,
  members: {
    list: [],
    isLoading: true,
    error: null,
    total: 0,
  },
};

const useTeamStore = create((set, get) => ({
  ...initialState,
  setTeamMembers: (members, total, isLoading, error = null) => set((state) => ({
    members: {
      ...state.members,
      list: members,
      total,
      isLoading,
      error,
    },
  })),
  setTeamName: (name) => set({ name }),
  reset: () => set({ ...initialState }),
}));

export default useTeamStore;
